import React, { useState, useRef, useEffect } from "react";
import styles from "./WhatsappBookingForm.module.css";

const CustomDropdown = ({
  value,
  onChange,
  options = [],
  placeholder = "-- Choose an Option --",
  showSearch = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const selectedOption = options.find((opt) => String(opt.value) === String(value));

  const filteredOptions = options.filter((opt) => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    const searchTarget = (opt.searchLabel || opt.label || "").toLowerCase();
    return searchTarget.includes(term);
  });

  return (
    <div className={styles.customSelectWrapper} ref={dropdownRef}>
      <button
        type="button"
        className={`${styles.customSelectTrigger} ${isOpen ? styles.customSelectTriggerOpen : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className={styles.triggerText}>
          {selectedOption ? (
            selectedOption.renderLabel || selectedOption.label
          ) : (
            <span className={styles.placeholderText}>{placeholder}</span>
          )}
        </span>
        <span className={styles.triggerArrow}>▾</span>
      </button>

      {isOpen && (
        <div className={styles.customDropdownMenu}>
          {showSearch && options.length > 6 && (
            <div className={styles.searchBoxWrapper}>
              <input
                type="text"
                placeholder="Search options..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={styles.searchBox}
                autoFocus
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
          <div className={styles.optionsList} role="listbox">
            {filteredOptions.length === 0 ? (
              <div className={styles.noOptions}>No matches found</div>
            ) : (
              filteredOptions.map((opt) => {
                const isSelected = String(opt.value) === String(value);
                const isDisabled = Boolean(opt.disabled);
                return (
                  <div
                    key={opt.value}
                    role="option"
                    aria-selected={isSelected}
                    aria-disabled={isDisabled}
                    className={`${styles.optionItem} ${
                      isSelected ? styles.optionItemSelected : ""
                    } ${isDisabled ? styles.optionItemDisabled : ""}`}
                    onClick={() => {
                      if (isDisabled) return;
                      onChange(opt.value);
                      setIsOpen(false);
                      setSearchTerm("");
                    }}
                  >
                    {opt.renderOption || opt.label}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
